export function onlyNumber(event) {
    if (!/[0-9]/.test(event.key)) event.preventDefault();
}
export function formatVND(amount) {
    return amount.toLocaleString("vi-VN", { style: "currency", currency: "VND" });
}
export function formatNumber(value) {
  if (!value) return '';
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function unformatNumber(value) {
  return value.replace(/\D/g, '');
}